/**
 * Whether a website/account plan meets an integration's plan_tier for
 * sync features (contact push, integration actions) and hard-gated connects.
 */
export function websiteMeetsIntegrationPlanTier({
  planType,
  websitePremium,
  planTier,
} = {}) {
  const tier = String(planTier || "free");
  if (!tier || tier === "free") {
    return true;
  }

  const premium =
    websitePremium === true ||
    websitePremium === "true" ||
    websitePremium === 1 ||
    websitePremium === "1";

  if (!premium) {
    return false;
  }

  const plan = String(planType || "free");

  if (tier === "personal") {
    return true;
  }

  if (tier === "prime") {
    return (
      ["2026_personal", "2024_pages", "2024_core"].includes(plan) === false
    );
  }

  if (tier === "pro") {
    return (
      ["2026_personal", "2026_prime", "2024_pages", "2024_core"].includes(
        plan
      ) === false
    );
  }

  if (tier === "plus") {
    return (
      [
        "2026_personal",
        "2026_prime",
        "2026_pro",
        "2025_pro",
        "2024_pages",
        "2024_funnels",
        "2024_core",
        "2024_pro",
      ].includes(plan) === false
    );
  }

  if (tier === "enterprise") {
    return (
      ["2026_personal", "2026_prime", "2026_pro", "2026_plus"].includes(
        plan
      ) === false
    );
  }

  return true;
}

export function integrationUpgradePlan(planTier) {
  const tier = String(planTier || "pro");
  if (tier === "personal") {
    return "paid";
  }
  if (["prime", "pro", "plus", "enterprise"].includes(tier)) {
    return tier;
  }
  return "pro";
}

export default websiteMeetsIntegrationPlanTier;
